module.exports = __webpack_public_path__ + "img/title.f5f87cd9.png";